import "./styles.scoped.css";
export default {
    "button-trigger": "awsui_button-trigger_18eso_15xui_97",
    "arrow": "awsui_arrow_18eso_15xui_97",
    "has-caret": "awsui_has-caret_18eso_15xui_135",
    "placeholder": "awsui_placeholder_18eso_15xui_138",
    "pressed": "awsui_pressed_18eso_15xui_151",
    "disabled": "awsui_disabled_18eso_15xui_154",
    "in-filtering-token": "awsui_in-filtering-token_18eso_15xui_163",
    "read-only": "awsui_read-only_18eso_15xui_169",
    "invalid": "awsui_invalid_18eso_15xui_186"
};
